import { render, staticRenderFns } from "./appointticket.vue?vue&type=template&id=b780d2e6&scoped=true&"
import script from "./appointticket.vue?vue&type=script&lang=js&"
export * from "./appointticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b780d2e6",
  null
  
)

export default component.exports